import React from "react";
import "./LegalPages.css";

export default function Terms() {
  return (
    <div className="pp-legal-page">
      <div className="pp-container">
        <div className="pp-legal-shell">
          <div className="pp-legal-hero">
            <div className="pp-legal-badge">Terms of Service</div>
            <h1>Terms for using the PresentPlus platform</h1>
            <p>
              These terms set out the basic responsibilities, acceptable use and
              service expectations for PresentPlus users and organisations.
            </p>
          </div>

          <div className="pp-legal-content">
            <section>
              <h2>1. Overview</h2>
              <p>PresentPlus is a cloud-based school operations platform provided by CoreLogic Systems Ltd.</p>
            </section>

            <section>
              <h2>2. Responsibilities</h2>
              <p>Users must ensure lawful use of the platform, accurate data entry and appropriate use of school information.</p>
            </section>

            <section>
              <h2>3. Data Ownership</h2>
              <p>All school data remains the property of the school or organisation responsible for that data.</p>
            </section>

            <section>
              <h2>4. Acceptable Use</h2>
              <ul>
                <li>No misuse of the system</li>
                <li>No unauthorised access attempts</li>
                <li>No disruption of service</li>
                <li>No use outside authorised school purposes</li>
              </ul>
            </section>

            <section>
              <h2>5. Availability</h2>
              <p>We aim to provide reliable service availability, but we do not guarantee uninterrupted access at all times.</p>
            </section>

            <section>
              <h2>6. Liability</h2>
              <p>We are not liable for indirect losses or misuse of the system by unauthorised or negligent users.</p>
            </section>

            <section>
              <h2>7. Governing Law</h2>
              <p>These terms are governed by the laws of England and Wales.</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
